import React from "react";
import { VMProvider } from "../../commons/base/providers/provider";
import FormOpsReminderCreateViewModel from "./view_models/form_ops_reminder_create_view_model";
import Scaffold from "../../commons/scaffold/scaffold";
import { OutletType } from "../models/outlet_type_enum";
import OutletTypeDropdownWidget from "../widgets/outlet_type_dropdown_widget";
import TitleAndContentTextInput from "../widgets/title_and_content_text_input";
import OutletSelectionToggleWidget from "../widgets/outlet_selection_toggle_widget";
import ScheduleTableWidget from "../widgets/schedule_table_widget";

export default class FormOpsReminderCreateScreen extends React.Component {
    render(): React.ReactNode {
        return (
            <VMProvider create={() => new FormOpsReminderCreateViewModel()}>
                {(vm) => (
                    <Scaffold
                        isShowLoading={vm.isLoading}
                        loadingBackgroundColor="semi_transparent"
                        showErrorView={vm.errorModel}
                        showSnackbar={vm.snackbarModel}
                    >
                        <div className="bg-slate-500 overflow-x-auto min-h-screen p-5 my-10 pb-10 relative">
                            <h1 className="text-white text-3xl text-center font-bold mb-10">
                                Create Form Ops Reminder
                            </h1>

                            <div className="space-y-6 max-w-4xl mx-auto">
                                {/* Title dan Content */}
                                <TitleAndContentTextInput
                                    title={vm.title}
                                    onChangeTitle={(value) =>
                                        vm.updateTitle(value)
                                    }
                                    content={vm.content}
                                    onChangeContent={(value) =>
                                        vm.updateContent(value)
                                    }
                                />

                                {/* Tabel Schedule */}
                                <ScheduleTableWidget
                                    scheduleMap={vm.scheduleMap}
                                    onUpdateSchedule={(value) =>
                                        vm.updateSchedule(value)
                                    }
                                />

                                {/* Tipe Outlet */}
                                <OutletTypeDropdownWidget
                                    selectedOption={vm.outletType}
                                    onChange={(value) =>
                                        vm.updateOutletType(value)
                                    }
                                />

                                {/* Pilihan Outlet */}
                                {vm.outletType === OutletType.CUSTOM && (
                                    <OutletSelectionToggleWidget
                                        outletOptions={vm.outletsInOptions}
                                        selectedOutletsMap={
                                            vm.selectedOutletsMap
                                        }
                                        onToggleOutlet={(value) =>
                                            vm.toggleOutlet(value)
                                        }
                                    />
                                )}

                                <button
                                    className="w-full p-1 bg-green-500 rounded-md text-white"
                                    onClick={() =>
                                        vm.submitForm({
                                            onSuccess: () => window.location.href = "/form-ops-reminder",
                                        })
                                    }
                                >
                                    {vm.isSubmitting ? "..." : "Submit Form"}
                                </button>
                            </div>
                        </div>
                    </Scaffold>
                )}
            </VMProvider>
        );
    }
}
